import MoreBtn from 'OK/menu/main/MoreBtn';
import scrollHelper from 'OK/utils/scrollHelper';

class NavMenu {
    constructor() {
        this.options = {
            itemCls: '',
            itemClsActive: '',
            scMenuCls: '',
            setVisible: '',
            withIcoProcess: '',
            btnMore: '.mctc_navMenuDropdownSec',
            btnMoreCls: '',
            btnMoreTitle: 'More',
            invisibleHeaderSelector: null
        };
    }

    activate(el) {

        this._el = el;

        this._initOptions(el.dataset);

        var excludeItems = [], items = [], children = el.children, options = this.options, itemCls = options.itemCls,
            scrollToView = el.getAttribute('data-scroll-to-view'), moreBtnEl;

        if (options.btnMoreCls) {
            moreBtnEl = document.createElement('a');
            moreBtnEl.scMenuCls = options.scMenuCls;
            moreBtnEl.className = options.btnMoreCls;
            moreBtnEl.innerHTML = options.btnMoreTitle;
            el.appendChild(moreBtnEl);
        } else {
            moreBtnEl = el.querySelector(options.btnMore);
        }

        if (options.invisibleHeaderSelector) {
            this._invisibleHeader = document.querySelector(options.invisibleHeaderSelector);
        }

        this._moreBtnEl = moreBtnEl;

        excludeItems.push(this._moreBtnEl);

        for (var i = 0; i < children.length; i++) {
            if (this._moreBtnEl !== children[i]) {
                if (children[i].classList.contains(itemCls)) {
                    items.push(children[i]);
                } else {
                    excludeItems.push(children[i]);
                }
            }
        }

        this._excludeItems = excludeItems;
        this._items = items;

        this._moreBtn = new MoreBtn({
            el: this._moreBtnEl
        });

        this._checkItems();

        if (scrollToView) {
            scrollToView = Number(scrollToView);
            if (isNaN(scrollToView)) {
                scrollToView = 0;
            }
            if (scrollToView >= 0) {
                this._scrollTimeoutId = setTimeout(function () {
                    scrollHelper.scrollIntoOKViewport(el);
                }, scrollToView);
            }
        }
    }

    _initOptions(options) {
        Object.assign(this.options, options);
    }

    _checkItems() {

        var moreBtn = this._moreBtn, morBtnEl = moreBtn.getEl(), el = this._el, elStyle = window.getComputedStyle(el),
            excludeItems = this._excludeItems, itemClsActive = this.options.itemClsActive,
            setVisible = this.options.setVisible, withIcoProcess = this.options.withIcoProcess, items = this._items,
            invisibleHeader = this._invisibleHeader, availableWidth = 0, excludeItem, excludeItemStyle, itemWidth,
            itemStyle, item, i;

        morBtnEl.style.display = '';

        availableWidth = el.offsetWidth - parseFloat(elStyle.paddingLeft) - parseFloat(elStyle.paddingRight);

        for (i = 0; i < excludeItems.length; i++) {
            excludeItem = excludeItems[i];
            excludeItemStyle = window.getComputedStyle(excludeItem);
            availableWidth -= excludeItem.offsetWidth + parseFloat(excludeItemStyle.marginLeft) + parseFloat(excludeItemStyle.marginRight);
        }

        for (i = 0; i < items.length; i++) {
            item = items[i];
            itemStyle = window.getComputedStyle(item);
            itemWidth = item.offsetWidth + parseFloat(itemStyle.marginLeft) + parseFloat(itemStyle.marginRight);

            if (itemWidth < availableWidth) {
                availableWidth -= itemWidth;
            } else {
                break;
            }
        }

        var newMenuItems = items.splice(i), newMenuItem, menuActive = false;

        for (i = 0; i < newMenuItems.length; i++) {
            newMenuItem = newMenuItems[i];

            if (itemClsActive && newMenuItem.classList.contains(itemClsActive)) {
                menuActive = true;

                if (invisibleHeader != null && invisibleHeader.classList.contains('invisible')) {
                    invisibleHeader.classList.remove('invisible');
                }
            }

            if (withIcoProcess) {
                newMenuItem.classList.remove('__without-ico');
            }

            moreBtn.addItem(newMenuItem);
        }

        if (!newMenuItems.length) {
            morBtnEl.style.display = 'none';
        }

        if (menuActive) {
            morBtnEl.classList.add(itemClsActive);
        }

        if (setVisible) {
            el.style.overflow = 'visible';
        }
    }

    deactivate() {
        clearTimeout(this._scrollTimeoutId);
        this._moreBtn.destroy();
        OK.util.clean(this);
    }
}


export default NavMenu;
